import axios from 'axios';
import httpClient from '../httpClient';
import store from 'redux/configureStore';

export const getUsers = (showNudgeUsers) => {
    return httpClient
        .get(`/api/v2/account/user_list?help=false&count=false&page=1&itemsOnPage=9999$${showNudgeUsers ? '&nudgeEmailRule=true' : ''}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const assignMultipleAlertsToUser = (userId, sourceIds, type) => {
    let baseStr = '';
    sourceIds.length > 0 && sourceIds.map(id => {
        return baseStr += `&sources%5B%5D=${id}`;
    });
    let url = `/api/v2/account/${userId}/add_alert?${baseStr}&type=${type}`;
    return httpClient
        .get(url)
        .then((res) => res.data)
        .catch((e) => {
            console.log(e);
            throw e.response.data.content;
        });
};

export const assignNudgeAlerts = (userId, entities) => {
    return httpClient
        .post(`/api/v2/account/${userId}/add_nudge_alert`, {entities})
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};